"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhotoViewerModal = void 0;
var React = require("react");
var uuid_1 = require("uuid");
var keyboard = require("../../../_Core/Keyboard");
var Icons_1 = require("../../../Icons");
var Indicators_1 = require("../../../Indicators");
var Localization_1 = require("../../../Localization");
var PortalWrapper_1 = require("../../BaseModal/components/PortalWrapper");
var Image_1 = require("../components/Image");
var PhotoViewer_styles_1 = require("../PhotoViewer.styles");
var PhotoViewerModal = function (_a) {
    var AltText = _a.AltText, ImgRole = _a.ImgRole, ImgSource = _a.ImgSource, PopupHeader = _a.PopupHeader, OnClose = _a.OnClose, LoadingSource = _a.LoadingSource;
    var closeButtonRef = React.createRef();
    var idToUse = uuid_1.v1();
    var _b = React.useState({
        imageOpacity: 0,
        index: 0,
    }), state = _b[0], setState = _b[1];
    React.useEffect(function () {
        if (closeButtonRef.current) {
            closeButtonRef.current.focus();
        }
    }, []);
    var stopClick = function (e) {
        e.stopPropagation();
    };
    var handleCloseAction = function (e) {
        e.stopPropagation();
        OnClose();
    };
    var handleKeyDown = function (e) {
        e.stopPropagation();
        if (keyboard.IsEscape(e)) {
            OnClose();
        }
    };
    var handleOnImageLoad = function (e) {
        setState(__assign(__assign({}, state), { height: e.target.naturalHeight + PhotoViewer_styles_1.MODAL_HEADER_HEIGHT + 1, imageOpacity: 1, width: e.target.naturalWidth }));
    };
    return (React.createElement(PortalWrapper_1.PortalWrapper, null,
        React.createElement(PhotoViewer_styles_1.ModalDiv, { onClick: handleCloseAction },
            React.createElement(PhotoViewer_styles_1.MotionSection, { animate: __assign({}, state), role: "dialog", "aria-labelledby": idToUse, onClick: stopClick, onKeyDown: handleKeyDown, tabIndex: 0 },
                React.createElement(PhotoViewer_styles_1.ModalHeader, { onKeyDown: handleKeyDown },
                    React.createElement(PhotoViewer_styles_1.CaptionDiv, { id: idToUse }, PopupHeader),
                    React.createElement(PhotoViewer_styles_1.CloseButton, { type: "button", onClick: handleCloseAction, onKeyDown: handleKeyDown, title: Localization_1.strings.Action_ClosePopup, "aria-label": Localization_1.strings.Action_ClosePopup, ref: closeButtonRef },
                        React.createElement(Icons_1.CloseThinIcon, { Height: "24px", Width: "24px" }))),
                React.createElement(PhotoViewer_styles_1.Article, null,
                    React.createElement(PhotoViewer_styles_1.ContentContainerDiv, null,
                        (LoadingSource || state.imageOpacity === 0) &&
                            React.createElement(PhotoViewer_styles_1.LoaderContainerDiv, null,
                                React.createElement(Indicators_1.AreaLoader, null)),
                        React.createElement(Image_1.Image, { AltText: AltText, OnLoad: handleOnImageLoad, Role: ImgRole, Src: ImgSource, ShowImage: !LoadingSource && state.imageOpacity === 1 })))))));
};
exports.PhotoViewerModal = PhotoViewerModal;
